import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Antd
import Highlighter from 'react-highlight-words';
import {
    SearchOutlined,
} from '@ant-design/icons';
import { Button, Input, Space, Spin, Table, Tag } from 'antd';

import { useHistory, Link, useParams } from 'react-router-dom';

import { getAllUsers, getAllUsersOfACourse, getAttendanceBySession, getSessionById } from '../../../../Constants/Api/functions/function';

import dayjs from 'dayjs';

const SessionDetails = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [sessionData, setSessionData] = useState();
    const [session, setSession] = useState();
    const sessionId = useParams().id?.split('@')[0];
    const sessionTitle = useParams().id?.split('@')[1];
    const [sessionDate, setSessionDate] = useState();

    const [searchText, setSearchText] = useState('');
    const [tableData, setTableData] = useState([]);
    const searchInput = useRef(null);
    const [searchedColumn, setSearchedColumn] = useState('');

    const userProfile = useSelector(state => state.userProfile.userProfile);
    const [allUsers, setAllUsers] = useState();
    const allSessons = useSelector(state => state.allSessons.allSessons);
    const history = useHistory();

    useEffect(() => {
        if (!allUsers || allUsers.length === 0) {
            handleGetAllUsers();
        }
    }, [allUsers, session])

    useEffect(() => {
        if (userProfile?.role === 'student') {
            history.push(`/dashboard/home`)
        }
    }, [userProfile])

    useEffect(() => {
        if (session && allUsers?.length > 0) {
            handleGetSessionData();
        }
    }, [sessionId, allUsers])

    useEffect(() => {
        if (allSessons) {
            let session = allSessons.find((session) => session.id === sessionId);
            if (session && session.isRepeat) {
                let title = sessionTitle.split('-');
                let date = title[1].trim()

                session = { ...session, name: `${session.name} - ${date}` }

                let dateArray = date.split(' ');
                let month = dateArray[1];
                let day = dateArray[2];
                let year = dateArray[3];
                const months = {
                    Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
                    Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
                };
                let monthNum = months[month] || '01';
                let newDate = `${year}-${monthNum}-${day}`;
                setSessionDate(newDate);
            }

            setSession(session);
        } else {
            getSessionData();
        }
    }, [allSessons])

    useEffect(() => {
        if (sessionData) {
            let data = sessionData.map((user, index) => {
                return {
                    key: index,
                    name: user.name,
                    attendance: user.attendance?.isAttended || false,
                    attendanceTime: user.attendance?.createdAt ? dayjs(user.attendance?.createdAt).format('YYYY-MM-DD HH:mm:ss') : 'N/A',
                    role: user.role,
                    userId: user.id,
                    contactNumber: user.contactNumber,
                }
            });
            // Sort to show present participants on top
            data.sort((a, b) => (b.attendance ? 1 : 0) - (a.attendance ? 1 : 0));
            // Re-assign keys based on sorted indices
            data = data.map((item, index) => ({ ...item, key: index }));
            setTableData(data);
        }
    }, [sessionData])

    const handleGetAllUsers = async () => {
        setIsLoading(true);
        try {
            if (session?.isFree) {
                const response = await getAllUsers();
                if (response) {
                    setAllUsers(response)
                }
            } else {
                const response = await getAllUsersOfACourse(session?.courseId);
                if (response) {
                    setAllUsers(response)
                }
            }
        } catch (error) {
            console.error('getAllUsers', error);
        }
        setIsLoading(false);
    }

    const handleGetSessionData = async () => {
        setIsLoading(true);
        try {
            const response = await getAttendanceBySession(sessionId, session?.isRepeat || 'none', sessionDate || 'none');
            let data = response.map((att) => {
                return {
                    id: att.userId,
                    name: att.name,
                    role: 'student',
                    contactNumber: att.contactNumber || 'N/A',
                    attendance: att
                }
            });
            setSessionData(data);
        } catch (error) {
            console.error('handleGetSessionData', error);
        }
        setIsLoading(false);
    }

    const getSessionData = async () => {
        try {
            let response = await getSessionById(sessionId);
            if (response && response.isRepeat) {
                let title = sessionTitle.split('-');
                let date = title[1].trim()

                response = { ...response, name: `${response.name} - ${date}` }

                setSession(response);

                let dateArray = date.split(' ');
                let month = dateArray[1];
                let day = dateArray[2];
                let year = dateArray[3];
                const months = {
                    Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
                    Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
                };
                let monthNum = months[month] || '01';
                let newDate = `${year}-${monthNum}-${day}`;
                setSessionDate(newDate);

            } else if (response) {
                setSession(response);
            }
        } catch (error) {
            console.error('getSessionData', error);
        }
    }


    const handleExportToExcel = () => {
        if (sessionData.length > 0) {
            const sheetData = sessionData.map((user) => {
                return {
                    'ID': user.id,
                    'Name': user.name,
                    'Role': user.role,
                    'Attendance': user.attendance?.isAttended ? 'Present' : 'Absent',
                    'Attendance Time': user.attendance?.createdAt ? dayjs(user.attendance?.createdAt).format('YYYY-MM-DD HH:mm:ss') : 'N/A',
                }
            });

            import("xlsx").then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(sheetData);
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                saveAsExcelFile(excelBuffer, 'sessionData');
            });
        }
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], { type: EXCEL_TYPE });
            FileSaver.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getNameSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text, record) =>
            searchedColumn === dataIndex ? (
                <Link to={`/dashboard/users/${record.userId}/overview`}>
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                </Link>
            ) : (
                <Link to={`/dashboard/users/${record.userId}/overview`}>
                    <p
                        style={{
                            color: '#9373ff',
                            cursor: 'pointer',
                        }}
                    >
                        {text}
                    </p>
                </Link>
            ),
    });

    const columns = [
        {
            title: 'Student Name',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
            ...getNameSearchProps('name'),
        },
        {
            title: 'Contact Number',
            dataIndex: 'contactNumber',
            key: 'contactNumber',
            width: '20%',
            ...getNameSearchProps('contactNumber'),
        },
        {
            title: 'Attendance',
            dataIndex: 'attendance',
            key: 'attendance',
            width: '20%',
            filters: [
                {
                    text: 'Present',
                    value: true,
                },
                {
                    text: 'Absent',
                    value: false,
                },
            ],
            onFilter: (value, record) => record.attendance === value,
            render: (attendance) => {
                return (
                    <Tag color={attendance ? 'green' : 'red'}
                        key={attendance}>
                        {attendance ? 'Present' : 'Absent'}
                    </Tag>
                )
            }
        },
        {
            title: 'Adtendance Time',
            dataIndex: 'attendanceTime',
            key: 'attendanceTime',
            width: '20%',
            sorter: (a, b) => new Date(a.attendance?.time) - new Date(b.attendance?.time),
        }
    ];

    return (
        <div>
            <div
                className='header'
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <h1>
                    {session?.name}
                </h1>
                <h2
                    style={{
                        color: 'gray',
                        fontSize: 20,
                    }}
                >{`Date: `}
                    {session?.meetingDate || 'N/A'}
                </h2>

                {userProfile?.role === 'superadmin' &&
                    <Button
                        type='primary'
                        onClick={handleExportToExcel}
                    >
                        Export to Excel
                    </Button>}
            </div>
            <div className='table'>
                <Spin spinning={isLoading}>
                    <Table
                        columns={columns}
                        dataSource={tableData}
                        pagination={{
                            pageSize: 20,
                            showSizeChanger: false,
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
                        }}
                    />
                </Spin>
            </div>
        </div>
    )
}

export default SessionDetails